import styled from 'styled-components';

const Container = styled.div`
  padding: 0 2.75vw;
`;

export default Container;
